import { MOCK_DTCS } from "../mock/mockDtcs";

/**
 * DiagnosticsService — CAN bus DTC (Diagnostic Trouble Code) stream.
 * Swap this singleton for a real CAN telemetry adapter when available.
 * Real implementation must satisfy: { getDtcs, getNotificationDtcs }.
 */
export const DiagnosticsService = {
  /** @returns {{ id: string, node: string, description: string, timestamp: string, severity: string }[]} */
  getDtcs: () => MOCK_DTCS,

  /**
   * Returns DTCs shaped for the notifications pipeline.
   * @returns {{ id: string, severity: string, icon: string, title: string, body: string, actionLabel: string, target: string }[]}
   */
  getNotificationDtcs: () =>
    MOCK_DTCS.map((d) => ({
      id: `dtc-${d.id}`,
      severity: d.severity,
      icon: d.severity === "critical" ? "error" : "warning",
      title: `DTC ${d.id}`,
      body: `${d.node} — ${d.description}`,
      actionLabel: "View diagnostics",
      target: "diagnostics",
    })),
};
